
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'VariantInformation',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Products/VariantInformation/VariantInformation.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SearchResults',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Products/SearchResults/SearchResults.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ProductList',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Products/ProductList/ProductList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ProductOverview',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Products/ProductOverview/ProductOverview.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'InteractiveRange',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Products/InteractiveRange/InteractiveRange.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'RelatedProducts',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Products/RelatedProducts/RelatedProducts.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'StickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Navigation/StickyNavigation/StickyNavigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Navigation',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Navigation/Navigation/Navigation.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Breadcrumb',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Navigation/Breadcrumb/Breadcrumb.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Video',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/Video/Video.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Timeline',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/Timeline/Timeline.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SectionTitle',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/SectionTitle/SectionTitle.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ProductPromoTabs',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/ProductPromoTabs/ProductPromoTabs.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'IconList',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/IconList/IconList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ImageCarousel',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/ImageCarousel/ImageCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FeatureList',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/FeatureList/FeatureList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ImageWithText',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/ImageWithText/ImageWithText.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContentWithLogo',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Media/ContentWithLogo/ContentWithLogo.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContactForm',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Forms/ContactForm/ContactForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Footer',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Footers/Footer/Footer.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TabbedCarouselContent',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/TabbedCarouselContent/TabbedCarouselContent.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'RichTextArea',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/RichTextArea/RichTextArea.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Split6040',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/Split6040/Split6040.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ProductPromoHeader',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/ProductPromoHeader/ProductPromoHeader.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ProductFeaturePicker',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/ProductFeaturePicker/ProductFeaturePicker.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SplitCallout',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/SplitCallout/SplitCallout.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ProductBanner',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/ProductBanner/ProductBanner.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CookieText',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/CookieText/CookieText.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CentreText',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/CentreText/CentreText.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CookiePolicy',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/CookiePolicy/CookiePolicy.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Banner',
  import: (): Promise<any> => import('C:/agent/_work/3343/s/src/Empire.Web/wwwroot/SiteFiles/next-gen/src/stories/Widgets/Content/Banner/Banner.client'),
  config: {
  hydrate: 'in-view',
},
} 
];
  